/**
 * Is this a path on OUR site — safe to navigate to after we echo it back?
 *
 * Rooted ("/…") and nothing else. `//evil.com` is a protocol-relative URL, not a
 * local path, however much it looks like one. A backslash is refused too: URL
 * parsing treats `\` as `/` for special schemes, so `new URL("/\evil.com",
 * origin)` resolves to `https://evil.com/` — an offsite link a `//` check
 * alone waves through.
 *
 * Shared by the maintenance page's retry link and the post-sign-in redirect
 * on /landing (security review 2026-09-26, M3), which had drifted: the landing
 * page checked only `startsWith("/")`.
 */
export function isSafeLocalPath(path: string | null | undefined): path is string {
  if (!path || !path.startsWith("/") || path.startsWith("//")) return false;
  return !path.includes("\\");
}
